import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';

@Component({
    standalone: true,
    imports: [CommonModule, MatProgressBarModule, MatIconModule],
    selector: 'app-password-strength',
    templateUrl: './password-strength.component.html',
    styleUrls: ['./password-strength.component.scss'],
})
export class PasswordStrengthComponent {
    @Input() password = '';

    get strengthValue(): number {
        let score = 0;
        if (/[a-z]/.test(this.password)) score += 20;
        if (/[A-Z]/.test(this.password)) score += 20;
        if (/[0-9]/.test(this.password)) score += 20;
        if (/[^A-Za-z0-9]/.test(this.password)) score += 20;
        if (this.password.length >= 14) score += 20;
        return Math.min(score, 100);
    }

    get strengthLabel(): string {
        if (this.strengthValue < 40) return 'Weak';
        if (this.strengthValue < 80) return 'Medium';
        return 'Strong';
    }

    get requirements() {
        return [
            { label: 'At least 14 characters', valid: this.password.length >= 14 },
            { label: 'At least 1 number', valid: /\d/.test(this.password) },
            { label: 'At least 1 lowercase letter', valid: /[a-z]/.test(this.password) },
            { label: 'At least 1 uppercase letter', valid: /[A-Z]/.test(this.password) },
            { label: 'At least 1 special character', valid: /[@$!%*?&]/.test(this.password) },
        ];
    }

}